// extracted by mini-css-extract-plugin
export default {"iconBlock":"TooltipIconLayout_iconBlock__YPTV6","layer":"TooltipIconLayout_layer__AOqN2"};